import React, { memo, useId } from 'react';

/**
 * Эскиз квадрата со стороной a.
 *
 * @param {number|string} newPartSide – длина стороны (мм)
 * @param {boolean}       hasError    – true → размеры выводятся красным
 */
function SquarePreview({ newPartSide, hasError = false }) {
  const a = Number(newPartSide) || null;          // приводим к числу либо null
  const markerId  = useId();                      // уникальный id → несколько SVG на странице не конфликтуют

  const dimColor  = hasError ? '#ff4d4f' : 'black';
  const lineColor = '#4487C4'; // Sky Blue

  /* геометрия макета */
  const SQ_X   = 110;   // левый-верхний угол
  const SQ_Y   = 60;
  const SQ_LEN = 220;

  const GAP_TOP   = 20;   // вынос стрелок
  const GAP_LEFT  = 30;

  const topY    = SQ_Y - GAP_TOP;
  const leftX   = SQ_X - GAP_LEFT;
  const bottomY = SQ_Y + SQ_LEN;
  const rightX  = SQ_X + SQ_LEN;

  return (
    <svg width="100%" style={{ maxWidth: '420px', height: 'auto' }} viewBox="0 0 420 330">
      <defs>
        <marker
          id={markerId}
          viewBox="0 0 10 10"
          refX="10"
          refY="5"
          markerWidth="10"
          markerHeight="10"
          orient="auto-start-reverse"
          markerUnits="userSpaceOnUse"
        >
          <path d="M0 0L10 5L0 10Z" fill={lineColor} />
        </marker>
      </defs>

      {/* Контур квадрата */}
      <rect
        x={SQ_X}
        y={SQ_Y}
        width={SQ_LEN}
        height={SQ_LEN}
        fill="none"
        stroke={lineColor}
        strokeWidth="2"
      />

      {/* горизонтальный размер */}
      <line
        x1={SQ_X}  y1={topY}
        x2={rightX} y2={topY}
        stroke={lineColor} strokeWidth="2"
        markerStart={`url(#${markerId})`} markerEnd={`url(#${markerId})`}
      />
      <text
        x={(SQ_X + rightX) / 2}
        y={topY - 8}
        textAnchor="middle"
        fontFamily="Commissioner"
        fontSize="16" fontWeight="600"
        fill={dimColor}
      >
        {a ? `${a} мм` : '? мм'}
      </text>

      {/* вертикальный размер */}
      <line
        x1={leftX} y1={SQ_Y}
        x2={leftX} y2={bottomY}
        stroke={lineColor} strokeWidth="2"
        markerStart={`url(#${markerId})`} markerEnd={`url(#${markerId})`}
      />
      <text
        x={leftX - 8}
        y={(SQ_Y + bottomY) / 2}
        textAnchor="middle"
        fontFamily="Commissioner"
        fontSize="16" fontWeight="600"
        fill={dimColor}
        transform={`rotate(-90 ${leftX - 8} ${(SQ_Y + bottomY) / 2})`}
      >
        {a ? `${a} мм` : '? мм'}
      </text>

      {/* подпись «Сторона a» */}
      <text
        x={SQ_X + 10}
        y={(SQ_Y + bottomY + 15) / 2}
        textAnchor="middle"
        dominantBaseline="middle"
        fontFamily="Commissioner"
        fontSize="14" fontWeight="400"
        fill="black"
        transform={`rotate(-90 ${SQ_X + 10} ${(SQ_Y + bottomY) / 2})`}
      >
        Сторона a
      </text>
    </svg>
  );
}

export default memo(SquarePreview);
